import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Dashboard-listing--------------------------
export const dashboardDataApi = async () => {
  const endPoint = `dashboard/list`;

  return await axios.get(endPoint, setJwtToken());
};

export const getDashboardDetailApi = async () => {
  const endPoint = `dashboard`;
  return await axios.get(endPoint, setJwtToken());
};

export const dashboardAnalyticsGraphDataApi = async () => {
  const endPoint = `dashboard/analytics`;
  return await axios.get(endPoint, setJwtToken());
};

export const dashbaordCompletionRateApi = async () => {
  const endPoint = `dashboard/completion_rate`;
  return await axios.get(endPoint, setJwtToken());
};

export const dashboardSubscriptionDataApi = async () => {
  const endPoint = `dashboard/subscription_distribution`;
  return await axios.get(endPoint, setJwtToken());
};


export const dashboardUserOutfitHandlerApi = async () => {
  const endPoint = `dashboard/user_activity_stats`;
  return await axios.get(endPoint, setJwtToken());
};